module.exports = __webpack_public_path__ + "media/theme/icon__name-e2f2811e.svg";